
$( document ).ready(function() {
    progress.init();

    // localStorage.removeItem("background-jobs");
    if (!$('body').is('.guest')) {
        var jobs = localStorage.getItem("background-jobs");
        if (jobs != null) {
            if (Object.keys(jobs).length > 0) {
                progress.bgJobTimer = setInterval(progress.checkBackgroundJobs, 3000);
            }
        }
    }
});

var progress = {
    progressEl: null,
    progressText: null,
    progressState: null,
    bgJobTimer: null,
    bgJobs: {},

    init: function() {
        this.progressEl = $('#app-state');
        this.progressText = this.progressEl.find('.text');
        this.progressState = this.progressEl.find('.state');
        this.updateJobsIndicator();
    },

    startProgress: function(message) {
        progress.progressEl.addClass('loading');
        progress.setState(5);
        progress.setText(message || "Lade ...");
    },

    endProgress: function() {
        progress.progressEl.removeClass('loading');
        progress.setText("");
        progress.setState(0);
    },

    setText: function(message) {
        progress.progressText.html(message);
    },

    setState: function(state) {
        progress.progressState.css({
            width: state + '%'
        });
    },

    startBackground: function(url, options) {
        connection.getJson(url, {
            data: options.data,
            type: options.type,
            onSuccess: function(data) {
                console.log('startBackground '+data.pid);
                if (progress.bgJobTimer != null) clearInterval(progress.bgJobTimer);
                var jobs = localStorage.getItem("background-jobs") || '{}';
                jobs = JSON.parse(jobs);
                jobs[data.pid] = data.pid;
                localStorage.setItem("background-jobs", JSON.stringify(jobs));
                if (options.onStarted) options.onStarted(data);

                progress.bgJobs[data.pid] = options || {};
                progress.bgJobTimer = setInterval(progress.checkBackgroundJobs, 3000);
                progress.updateJobsIndicator();
            },
            onError: function(data) {
                if (options.onValidationError) options.onValidationError(data);
            }
        });
    },

    checkBackgroundJobs: function() {
        if (document.hidden) {
            return;
        }
        console.log('checkBackgroundJobs ...');
        var jobs = localStorage.getItem("background-jobs") || '{}';
        jobs = JSON.parse(jobs);
        connection.getJson('/Auth/CheckBackgroundJobs', {
            data: {
                jobs: jobs
            },
            onSuccess: function(data) {
                console.log('checkBackgroundJobs onSuccess: ');
                var jobs = localStorage.getItem("background-jobs") || '{}';
                jobs = JSON.parse(jobs);
                $.each(data, function(i, result) {
                    // successfully ended
                    if (result.status === 200) {
                        delete jobs[i];
                        //
                        if (progress.bgJobs[i] != null) {
                            connection.handleResponse(result.response);
                            if (progress.bgJobs[i].onFinished != null) progress.bgJobs[i].onFinished(result.response);
                        } else {
                            connection.handleResponse(result.response);
                            messaging.showPermanentGlobalMessage('success', 'Erfolgreich!', result?.response?.html || '', -1);
                        }

                        var finishedJobs = sessionStorage.getItem("finished-jobs") || '{}';
                        finishedJobs = JSON.parse(finishedJobs);
                        finishedJobs[i] = result.response;
                        sessionStorage.setItem("finished-jobs", JSON.stringify(finishedJobs));

                    } else if (result.status === 404) {
                        messaging.showPermanentGlobalMessage('error', 'Fehler', result.message, 5000);
                        delete jobs[i];
                    } else {
                        delete jobs[i];
                        if (progress.bgJobs[i] != null) {
                            if (progress.bgJobs[i].onError != null) progress.bgJobs[i].onError(result);
                        } else {
                            messaging.showPermanentGlobalMessage('danger', 'Error', result.error, -1);
                        }
                    }
                });
                if (Object.keys(jobs).length === 0) {
                    if (progress.bgJobTimer != null) clearInterval(progress.bgJobTimer);
                    localStorage.removeItem("background-jobs");
                } else {
                    localStorage.setItem("background-jobs", JSON.stringify(jobs));
                }
                progress.updateJobsIndicator();
            },
            onError: function() {
                debugger;
            }
        });
    },

    updateJobsIndicator: function() {
        // @todo: improve feedback first
    //     var container = $('#jobs-container');
    //     var jobs = localStorage.getItem("background-jobs") || '{}';
    //     jobs = JSON.parse(jobs);
    //     var finishedJobs = sessionStorage.getItem("finished-jobs") || '{}';
    //     finishedJobs = JSON.parse(finishedJobs);
    //     if (Object.keys(jobs).length + Object.keys(finishedJobs).length === 0) {
    //         container.empty();
    //     } else {
    //         var dropdown = $(`<div class="dropdown mr-2">
    //             <div class="btn btn-light dropdown-toggle" id="jobsHeaderDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    //                 <i class="bi bi-repeat"></i>
    //             </div>
    //             <div class="dropdown-menu dropdown-lined dropdown-menu-right" style="width:40rem;" aria-labelledby="jobsHeaderDropdown">
    //             </div>
    //         </div>`);
    //         $.each(jobs, function(i, job) {
    //             dropdown.find('.dropdown-menu').prepend(`<div class="py-2 px-3 text-margin-0">${JSON.stringify(job)}</div>`);
    //         });
    //         $.each(finishedJobs, function(i, job) {
    //             dropdown.find('.dropdown-menu').prepend(`<div class="py-2 px-3 text-margin-0">${job.html}</div>`);
    //         });
    //         container.html(dropdown);
    //     }
    },

};
window.progress = progress;

var ModalProgress = function(options) {
    this.loaderElement = null;
    this.options = {
        onSuccess: null,
        onFail: null,
        title: '',
        message: '',
        width: 400,
        cssClass: '',
        contentCssClass: ''
    };

    $.extend(this.options, options);

    ModalProgress.prototype.start = function () {
        this.loaderElement = $('<div id="modal-progress-box" class="modal fade '+this.options.cssClass+'">' +
            '  <div class="modal-dialog modal-dialog-centered" role="document">' +
            '    <div class="modal-content">' +
            '      <div class="modal-header"><h5 class="modal-title">'+(this.options.title || "&nbsp;")+'</div>' +
            '      <div class="modal-body '+this.options.contentCssClass+'">' +
            (this.options.message || "Lade ...") +
            '      </div>' +
            '    </div>' +
            '  </div>' +
            '</div>');
        this.loaderElement.appendTo($('body'));
        this.loaderElement.modal('show');
    };

    ModalProgress.prototype.end = function () {
        this.loaderElement.modal('hide');
    };

    ModalProgress.prototype.setContent = function (htmlContent) {
        this.loaderElement.find('.content').html(htmlContent);
    };

}
